import { useGates } from "../state/use-gates";

export const Gate = ({ id }) => useGates(id);
